export enum SOPAgreementType {
  GENERAL_PRACTITIONER = "generalPractitioner",
  SPECIALIST_WITH_OPERATING_AGREEMENT = "specialistWithOperatingAgreement",
  WITHOUT_AGREEMENT = "withoutAgreement",
  SUBSTITUTE = "substitute",
}
